export const OPTIMIZELY_EVENTS = {
	BID_PLACED: 'Bid placed event',
	CONDITION_AND_DAMAGE_PHOTO_CLICKED: 'Condition and damage photo clicked',
	RECOMMENDED_SORT_ORDER_BOUNCE_RATE: 'Recommended sort order bounce rate event',
	VEHICLE_CARD_CLICKED: 'Vehicle card clicked event',
	VEHICLE_VIEWED: 'Vehicle viewed event',
};

// These are actually flag keys
export enum EXPERIMENTS {
	ADDITIONAL_PHOTOS = 'additional_photos',
	DEALER_DASHBOARD = 'dealer_dashboard_experiment',
	EARLY_DOCS_EXPERIMENT = 'early_docs_dealer_experiment',
	ENABLE_AI_COMPANION = 'enable_ai_companion',
	PRO_INFO_HIERARCHY = 'pro_info_hierarchy',
	RECOMMENDED_SORT_ORDER = 'explorers_recommended_sort_order_experiment',
	SEEN_VEHICLES_FILTER = 'seen_vehicles_filter',
	UNIT_TEST = 'unit_test',
	ZERO_PREV_OWNERS = 'zero_prev_owners',
}

/**
 * Maps Optimizely flag keys to FeaturesContext toggle names.
 *
 * Only add flags that use standard `getUserAttributesPayload` with no extra
 * runtime attributes. Flags requiring runtime attributes or a custom userId
 * must stay as dedicated hooks.
 */
export const OPTIMIZELY_TO_FE_FEATURE_FLAGS_MAP = {
	[EXPERIMENTS.PRO_INFO_HIERARCHY]: { feToggleName: 'proInfoHierarchy' },
} as const;

export type OptimizelyFeatureToggleName =
	(typeof OPTIMIZELY_TO_FE_FEATURE_FLAGS_MAP)[keyof typeof OPTIMIZELY_TO_FE_FEATURE_FLAGS_MAP]['feToggleName'];

/**
 * Maps Optimizely flag keys to FeaturesContext toggle names for multi-variant experiments.
 * Same rules as OPTIMIZELY_TO_FE_FEATURE_FLAGS_MAP (standard getUserAttributesPayload only).
 * The SSR seed writes the variationKey string into FeaturesContext instead of a boolean.
 */
// Example entry:
// [EXPERIMENTS.SOME_FLAG]: { feToggleName: 'someFlag', variants: { off: 'off', v1: 'v1', v2: 'v2' } },
export const OPTIMIZELY_VARIANT_FLAGS_MAP: Partial<
	Record<EXPERIMENTS, { feToggleName: string; variants: Record<string, string> }>
> = {};

export const EXPERIMENTS_DECISIONS = {
	DEALER_DASHBOARD: {
		off: 'off',
		on: 'on',
	},
	EARLY_DOCS_EXPERIMENT: {
		ON: 'on',
		SHOW_EARLY_DOCS: 'show_early_docs',
	},
	PRO_INFO_HIERARCHY: {
		SHOW_NEW_VEHICLE_LIST: 'show_new_vehicle_list',
		SHOW_OLD_VEHICLE_LIST: 'show_old_vehicle_list',
	},
	RECOMMENDED_SORT_ORDER: {
		off: 'off',
		v1: 'v1',
		v2: 'v2',
	},
} as const;

export const EXPERIMENTS_RULE_KEYS = {
	PRO_INFO_HIERARCHY: 'pro_info_hierarchy_experiment',
} as const;
